import { useTranslation } from "react-i18next";

import { type AreaWithSensorInfo, getBuildingById, getFloorById, useAppSelector } from "@lib/store";

// The area's name, with its seats and where it is
export const AreaSummary = ({ area }: { area: AreaWithSensorInfo }) => {
  const { t } = useTranslation();
  const building = useAppSelector(state => getBuildingById(state, area.buildingId));
  const floor = useAppSelector(state => getFloorById(state, area.floorId));

  const seats = t("meeting:MeetingRoomSeat", { count: area.capacity || area.adHocCapacity });

  return (
    <div className="flex flex-col gap-4">
      <h2 className="font-display text-[26px] font-medium leading-8">{area.name}</h2>
      <p>{[seats, building?.name, floor?.name].filter(Boolean).join(", ")}</p>
    </div>
  );
};
